// ═══════════════════════════════════════════════════════════════════
//  CourrielTuiles.js
//  Tuiles d'indicateurs de la boîte de réception — extrait de Courriel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { MailTuile } from "./MailTuile";

export function CourrielTuiles({ estBoiteRecue, isMobile, liste, stats }) {
  return (
    stats && estBoiteRecue && (
    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)", gap: 10, marginBottom: 16 }}>
      <MailTuile label="Non lus" valeur={liste?.unread ?? "—"} couleur={THEME.accent} />
      <MailTuile label="Reçus (7 j)" valeur={stats.semaine} couleur={THEME.gold} />
      <MailTuile label="Sans réponse > 48 h" valeur={stats.sansReponse}
                 couleur={stats.sansReponse > 0 ? THEME.red : THEME.textMuted}
                 aide="Hors messages traités, indésirables et automatiques" />
      <MailTuile label="Convertis en ticket" valeur={stats.tickets} couleur={THEME.emerald} />
    </div>
  )
  );
}
